import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AdminLayout from "../../layout/adminLayout";
import { environment, apiRoutes } from "../../auth/apiRoute";
import "./style.css";
import Axios from "axios";
import {
  Table,
  Tag,
  Space,
  message,
  notification,
  Popconfirm,
  Button,
  Divider,
  Input,
  Spin,
  Typography,
} from "antd";

const hotelNameCollator = new Intl.Collator("en", {
  numeric: true,
  sensitivity: "base",
});

const getHotelName = (record) => {
  if (!record) {
    return "";
  }
  if (record.hotel && record.hotel.name) {
    return record.hotel.name.trim();
  }
  if (record.name) {
    return record.name.trim();
  }
  return "";
};

const compareHotelNames = (a, b) => {
  const aName = getHotelName(a);
  const bName = getHotelName(b);

  if (!aName && !bName) {
    return 0;
  }
  if (!aName) {
    return 1;
  }
  if (!bName) {
    return -1;
  }

  const aStartsWithNumber = /^\d/.test(aName);
  const bStartsWithNumber = /^\d/.test(bName);

  if (aStartsWithNumber !== bStartsWithNumber) {
    return aStartsWithNumber ? -1 : 1;
  }

  return hotelNameCollator.compare(aName, bName);
};

export default function AdminDashboard() {
  useEffect(() => {
    setLoading(true);
    getNominations();
    getHotels();
    getQueryAndSetFilter();
    setLoading(false);
  }, []);
  const { Text, Paragraph } = Typography;
  const { Search } = Input;
  const [member, setMember] = useState({});
  const [loading, setLoading] = useState(false);
  const [hotels, setHotels] = useState([]);
  const [nominationsData, setNominationsData] = useState([]);
  const [filteredNominationsData, setFilteredNominationsData] = useState([]);
  const [filteredInfo, setFilter] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [search, setSearch] = useSearchParams();
  const categories = [
    "Full-Time Hourly With Guest Contact",
    "Full-Time Hourly Without Guest Contact",
    "Full-Time Room Attendant",
    "Managerial Below General Manager",
  ];
  const groupByJudge = (arr) => {
    var result = arr.reduce(function (r, a) {
      a.judge = a.judge || { firstName: "No", lastName: "Judge", _id: 0 };
      if (!r.some((item) => item._id === a.judge._id)) {
        r.push(a.judge);
      }

      return r;
    }, []);
    return result;
  };

  var finalJudges = {
    "Robert Koenig": "rkoenig@nyit.edu",
    "Jukka Laitamaki": "jl142@nyu.edu",
    "Seunghyun Park": "parks2@stjohns.edu",
  };

  const getHotels = async () => {
    try {
      const response = await Axios.post(apiRoutes[environment].hotels);

      if (response.status == 200) {
        var hotelsData = response.data;
        hotelsData = hotelsData.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        hotelsData.push({
          _id: "00000",
          name: "No Hotel",
        });

        setHotels(hotelsData);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };
  const getNominations = async () => {
    try {
      const response = await Axios.post(apiRoutes[environment].finalist);

      if (response.status == 200) {
        var nominations = response.data;
        nominations = nominations.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        console.log(nominations.slice(0, 5));
        setNominationsData(nominations);
        setFilteredNominationsData(nominations);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };

  const openNotification = (message) => {
    notification.success({
      message: `Success!`,
      description: "Your nomination has been successfully deleted! ",
      placement: "top",
    });
  };
  const onChange = (e) => {
    const value = e.target.value.toLowerCase();
    console.log(value);
    if (!value) {
      setFilteredNominationsData(nominationsData);
    } else if (value.length > 4) {
      var filters = nominationsData.filter((item) => {
        let keys = Object.keys(item);
        var bool = false;

        keys.forEach((key) => {
          if (key != "_id" && key != "key") {
            if (typeof item[key] === "string" && item[key]) {
              if (item[key].toLowerCase().includes(value)) {
                bool = true;

                return;
              }
            }
          }
        });
        return bool;
      });
      console.log(filters);
      setFilteredNominationsData([...filters]);
    }
  };
  const getQueryAndSetFilter = () => {
    const params = new URLSearchParams(search);

    var obj = {};
    for (const [key, val] of params.entries()) {
      console.log(key, val);
      if (
        key == "hotel" ||
        key == "category" ||
        key == "firstName" ||
        key == "score" ||
        key == "judge"
      ) {
        if (obj[key]) {
          obj[key].push(val);
        } else {
          obj[key] = [val.split(",")];
        }
      } else if (key == "current") {
        obj[key] = parseInt(val);
      } else {
        obj[key] = val;
      }
    }
    console.log(obj);

    if (obj) {
      setFilter(obj);
      setSortedInfo(obj);
    }
  };
  const onSearch = (value) => {
    if (!value) {
      setFilteredNominationsData(nominationsData);
    } else if (value.length > 2) {
      var filters = nominationsData.filter((item) => {
        let keys = Object.keys(item);
        var bool = false;

        keys.forEach((key) => {
          if (key != "_id" && key != "key") {
            if (typeof item[key] === "string" && item[key]) {
              if (item[key].toLowerCase().includes(value)) {
                bool = true;

                return;
              }
            }
          }
        });
        return bool;
      });
      console.log(filters);
      setFilteredNominationsData([...filters]);
    }
  };
  const clearFilters = () => {
    setFilter({ filteredInfo: null });
    setSearch("");
  };
  const handleChange = (pagination, filters, sorter) => {
    var newFilters = {};

    if (sorter.column) {
      for (const [key, val] of Object.entries(sorter)) {
        if (val) {
          newFilters[key] = val;
        }
      }

      // setSearch(newFilters);
    }
    if (
      filters.hotel ||
      filters.category ||
      filters.firstName ||
      filters.score ||
      filters.judge
    ) {
      for (const [key, val] of Object.entries(filters)) {
        if (val) {
          newFilters[key] = val;
        }
      }
      // console.log({ newFilters });
      // setFilter(newFilters);
      // setSearch(newFilters);
    }

    if (pagination) {
      newFilters["current"] = pagination.current;
      // console.log(newFilters);

      // setFilter(newFilters);
    }
    console.log(newFilters);
    setSearch(newFilters);
  };
  const checkIfAnswerClean = (record) => {
    const hotelName = record.hotel.name.split(" ");

    const questions = ["q1", "q2", "q3", "q4"];
    var contains = false;

    for (const question of questions) {
      if (!record[question].answer) {
        continue;
      }
      var containsHotelName = hotelName.some((item) =>
        record[question].answer.includes(item),
      );
      contains =
        record[question].answer.includes(record.firstName) ||
        record[question].answer.includes(record.firstName) ||
        containsHotelName;
    }

    return contains;
  };
  const getFirstTotal = (record) => {
    var total = 0;
    for (const q of ["q1", "q2", "q3", "q4"]) {
      if (record[q] && record[q].score) {
        total += parseFloat(record[q].score);
      }
    }

    return Math.floor(total * 10) / 10;
  };

  const getTotal = (record, judgeEmail) => {
    var total = 0;
    for (const q of ["q1", "q2", "q3", "q4"]) {
      if (
        record[q] &&
        record[q].finalScores &&
        record[q].finalScores[judgeEmail]
      ) {
        total += parseFloat(record[q].finalScores[judgeEmail]);
      }
    }

    return Math.floor(total * 10) / 10;
  };
  const getFinalScoresTotal = (record) => {
    var total = 0;
    for (const q of ["q1", "q2", "q3", "q4"]) {
      for (const judgeEmail of Object.values(finalJudges)) {
        if (
          record[q] &&
          record[q].finalScores &&
          record[q].finalScores[judgeEmail]
        ) {
          total += parseFloat(record[q].finalScores[judgeEmail]);
        }
      }
    }

    return Math.floor(total * 10) / 10;
  };
  const groupByCategory = (arr) => {
    var result = arr.reduce(function (r, a) {
      a.category = a.category || "No Category";
      r[a.category] = r[a.category] || [];
      r[a.category].push(a);
      return r;
    }, []);

    return result;
  };

  const getTopTenByCateogry = (nominationsData) => {
    var categorisedNominations = groupByCategory(nominationsData);
    var obj = {};
    for (const item of categories) {
      var categoryNomination = categorisedNominations[item];
      var result = categoryNomination.reduce((previous, current) => {
        if (previous.indexOf(getTotal(current)) === -1) {
          previous.push(getTotal(current));
        }

        return previous;
      }, []);

      obj[item] = result.sort((a, b) => b - a)[9];
    }

    return obj;
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",

      render: (text, record) => (
        <Link
          to={`/admin/nominations/${record._id}`}
          state={{
            nominations: filteredNominationsData.map((item) => item._id),
          }}
        >
          {record.firstName}
        </Link>
      ),
      onFilter: (value, record) => {
        return checkIfAnswerClean(record);
      },

      filteredValue: filteredInfo.firstName || null,
      filters: [{ text: "Contained", value: 0 }],
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      render: (text, record) => (
        <Link to={"/admin/nominations/" + record._id}>{text}</Link>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Hotel",
      dataIndex: "hotel",
      key: "hotel",
      filteredValue: filteredInfo.hotel || null,
      sortOrder: sortedInfo.columnKey === "hotel" && sortedInfo.order,
      filters: [...hotels].sort(compareHotelNames).map((hotel) => {
        return {
          text: hotel.name,
          value: hotel._id,
        };
      }),
      sorter: (a, b) => {
        return compareHotelNames(a, b);
      },
      filterSearch: true,
      onFilter: (value, record) => {
        if (value == "00000") {
          return !record.hotel;
        }
        if (record.hotel) {
          return record.hotel._id == value;
        }
      },
      render: (text, record) => {
        if (record.hotel) {
          return record.hotel.name;
        } else {
          return "";
        }
      },
    },
    {
      title: "Nominated By",
      dataIndex: "user",
      key: "user",
      sorter: (a, b) => a.user.lastName.localeCompare(b.user.lastName),
      sortOrder: sortedInfo.columnKey === "user" && sortedInfo.order,
      render: (text, record) =>
        record.user.firstName + " " + record.user.lastName,
    },
    {
      title: "Category",
      key: "category",
      dataIndex: "category",
      filteredValue: filteredInfo.category || null,
      sortOrder: sortedInfo.columnKey === "category" && sortedInfo.order,
      onFilter: (value, record) => record.category == value,
      filters: categories.map((item) => {
        return { text: item, value: item };
      }),
      sorter: (a, b) => a.category.localeCompare(b.category),
      render: (tag, record) => {
        const colors = ["volcano", "darkSalmon", "geekblue", "green"];
        const colorIndex = categories.findIndex((item) => item == tag);

        let color = colors[colorIndex];

        return (
          <Tag color={color} key={record._id}>
            {tag.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "First Round Score",
      key: "score",
      onFilter: (value, record) => {
        if (value == 0) {
          var total = 0;
          for (const q of ["q1", "q2", "q3", "q4"]) {
            if (record[q] && record[q].score) {
              total += parseFloat(record[q].score);
            }
          }
          return total == 0;
        }

        if (value == 1) {
          var standardsByCategory = getTopTenByCateogry(nominationsData);
          return (
            getTotal(record) >= standardsByCategory[record.category] &&
            record.excludedFromFinal != true
          );
        }
      },
      sortOrder: sortedInfo.columnKey === "score" && sortedInfo.order,
      sorter: (a, b) => {
        return getTotal(a) - getTotal(b);

        if (!getTotal || !b.hotel) {
          return true;
        } else {
          return a.hotel.name.localeCompare(b.hotel.name);
        }
      },
      filteredValue: filteredInfo.score || null,
      filters: [
        { text: "Un-scored", value: 0 },
        { text: "Top 10", value: 1 },
      ],
      render: (text, record) => {
        var total = getFirstTotal(record);
        return <>{String(total)}</>;
      },
    },

    ...Object.keys(finalJudges).map((judgeName) => {
      const judgeEmail = finalJudges[judgeName];
      return {
        title: `Final Score -- ${judgeName}`,
        key: `finalscoreby${judgeName.replace(/\s+/g, "")}`,

        sortOrder:
          sortedInfo.columnKey ===
            `finalscoreby${judgeName.replace(/\s+/g, "")}` && sortedInfo.order,
        sorter: (a, b) => {
          return getTotal(a, judgeEmail) - getTotal(b, judgeEmail);
        },
        render: (text, record) => {
          var total = getTotal(record, judgeEmail);
          return <>{String(total)}</>;
        },
      };
    }),
    // {
    //   title: "Final Score -- Joyce Leveston",
    //   key: "finalscorebyjoyceleveston",

    //   sortOrder:
    //     sortedInfo.columnKey === "finalscorebyjoyceleveston" &&
    //     sortedInfo.order,
    //   sorter: (a, b) => {
    //     return (
    //       getTotal(a, "JLeveston@javitscenter.com") -
    //       getTotal(b, "JLeveston@javitscenter.com")
    //     );
    //   },
    //   render: (text, record) => {
    //     var total = getTotal(record, "JLeveston@javitscenter.com");
    //     return <>{String(total)}</>;
    //   },
    // },
    // {
    //   title: "Final Score -- Jukka Laitamaki",
    //   key: "finalscorebyJukkaLaitamaki",

    //   sortOrder:
    //     sortedInfo.columnKey === "finalscorebyNicolasGraf" && sortedInfo.order,
    //   sorter: (a, b) => {
    //     return getTotal(a, "jl142@nyu.edu") - getTotal(b, "jl142@nyu.edu");
    //   },
    //   render: (text, record) => {
    //     var total = getTotal(record, "jl142@nyu.edu");
    //     return <>{String(total)}</>;
    //   },
    // },
    // {
    //   title: "Final Score -- Sean Hennessey",
    //   key: "finalscorebySeanHennessey",

    //   sortOrder:
    //     sortedInfo.columnKey === "finalscorebySeanHennessey" &&
    //     sortedInfo.order,
    //   sorter: (a, b) => {
    //     return getTotal(a, "sfh1@nyu.edu") - getTotal(b, "sfh1@nyu.edu");
    //   },
    //   render: (text, record) => {
    //     var total = getTotal(record, "sfh1@nyu.edu");
    //     return <>{String(total)}</>;
    //   },
    // },
    // {
    //   title: "Final Score -- Seunghyun Park",
    //   key: "finalscorebySeunghyunPark",

    //   sortOrder:
    //     sortedInfo.columnKey === "finalscorebySeunghyunPark" &&
    //     sortedInfo.order,
    //   sorter: (a, b) => {
    //     return (
    //       getTotal(a, "parks2@stjohns.edu") - getTotal(b, "parks2@stjohns.edu")
    //     );
    //   },
    //   render: (text, record) => {
    //     var total = getTotal(record, "parks2@stjohns.edu");
    //     return <>{String(total)}</>;
    //   },
    // },
    {
      title: "Final Total Score",
      key: "finaltotalscore",

      sortOrder: sortedInfo.columnKey === "finaltotalscore" && sortedInfo.order,
      sorter: (a, b) => {
        return getFinalScoresTotal(a) - getFinalScoresTotal(b);
      },
      render: (text, record) => {
        var total = getFinalScoresTotal(record);
        return <>{String(total)}</>;
      },
    },
  ];

  return (
    <Spin spinning={loading}>
      <Search
        style={{ width: "50%" }}
        placeholder="Search ..."
        onSearch={onSearch}
        enterButton
        onChange={onChange}
      />
      <Button onClick={clearFilters}>Clear filters</Button>

      <Paragraph>Total nominations: {nominationsData.length}</Paragraph>
      <Divider />
      <Table
        scroll={{
          x: 600,
        }}
        columns={columns}
        dataSource={filteredNominationsData}
        onChange={handleChange}
        pagination={{
          pageSize: filteredInfo.pageSize || 50,
          current: filteredInfo.current || 1,
        }}
      />
    </Spin>
  );
}
